@if (breadcrumbs()?.length) {
  <nav aria-label="Breadcrumb">
    <ol role="list" class="m-0 hidden items-center space-x-1.5 p-0 md:flex">
      @for (
        breadcrumb of breadcrumbs();
        track breadcrumb.path;
        let last = $last
      ) {
        <li class="flex items-center gap-1.5">
          @if (!last) {
            <a
              class="block truncate rounded-sm font-semibold leading-normal text-brand-primary-pure transition-colors duration-150 hover:text-brand-primary-dark"
              [class.text-sm]="size() === 'sm'"
              [class.text-base]="size() === 'md'"
              [class.text-lg]="size() === 'lg'"
              [routerLink]="[breadcrumb.path]"
              [queryParams]="breadcrumb.params"
            >
              <span>{{ breadcrumb.label }}</span>
            </a>

            <ng-icon
              name="featherChevronRight"
              size="20"
              class="shrink-0 text-neutral-low-light"
              aria-hidden="true"
            />
          } @else {
            <span
              class="font-medium leading-normal text-neutral-low-dark"
              [class.text-sm]="size() === 'sm'"
              [class.text-base]="size() === 'md'"
              [class.text-lg]="size() === 'lg'"
              aria-current="page"
            >
              {{ breadcrumb.label }}
            </span>
          }
        </li>
      }
    </ol>

    <div
      class="relative min-w-0 flex-1 md:hidden"
      [class.z-40]="ancestorMenuOpen()"
    >
      @if (hasNavigableAncestors() && parentBreadcrumb(); as parent) {
        <div class="flex min-w-0 items-center gap-1">
          <a
            class="flex min-w-0 flex-1 items-center gap-1 rounded-sm text-brand-primary-pure transition-colors duration-150 hover:text-brand-primary-dark"
            [routerLink]="[parent.path]"
            [queryParams]="parent.params"
            [attr.aria-label]="parent.label"
            (click)="closeAncestorMenu()"
          >
            <ng-icon
              name="featherChevronLeft"
              size="20"
              class="shrink-0 text-current"
              aria-hidden="true"
            />

            @if (currentBreadcrumb(); as current) {
              <span
                class="truncate font-medium leading-normal"
                [class.text-sm]="size() === 'sm'"
                [class.text-base]="size() === 'md'"
                [class.text-lg]="size() === 'lg'"
                aria-current="page"
              >
                {{ current.label }}
              </span>
            }
          </a>

          @if (showAncestorDropdown()) {
            <button
              type="button"
              class="flex h-8 w-8 shrink-0 items-center justify-center text-brand-primary-pure transition-colors duration-150 hover:text-brand-primary-dark"
              [attr.aria-expanded]="ancestorMenuOpen()"
              aria-label="Níveis anteriores"
              aria-haspopup="menu"
              [attr.data-expanded]="ancestorMenuOpen()"
              (click)="toggleAncestorMenu()"
            >
              <ng-icon
                name="featherChevronDown"
                size="16"
                class="size-4 shrink-0 text-current transition-transform duration-150"
                [class.rotate-180]="ancestorMenuOpen()"
                aria-hidden="true"
              />
            </button>
          }
        </div>

        @if (showAncestorDropdown()) {
          <ul
            class="pointer-events-none invisible absolute left-0 top-full z-40 mt-1 flex w-full min-w-full origin-top scale-y-0 flex-col rounded-md border border-brand-primary-lighter bg-neutral-hight-light p-2 opacity-0 shadow-sm transition-all duration-150 ease-out data-[expanded='true']:pointer-events-auto data-[expanded='true']:visible data-[expanded='true']:translate-y-1 data-[expanded='true']:scale-y-100 data-[expanded='true']:opacity-100"
            [attr.data-expanded]="ancestorMenuOpen()"
            [attr.aria-hidden]="!ancestorMenuOpen()"
            role="menu"
          >
            @for (ancestor of ancestorMenuItems(); track ancestor.path) {
              <li role="none">
                <a
                  class="block w-full truncate rounded-lg px-3 py-2 text-left font-roboto text-sm text-brand-primary-pure transition-colors duration-150 hover:bg-brand-primary-lighter hover:text-brand-primary-dark"
                  role="menuitem"
                  [routerLink]="[ancestor.path]"
                  [queryParams]="ancestor.params"
                  (click)="closeAncestorMenu()"
                >
                  {{ ancestor.label }}
                </a>
              </li>
            }
          </ul>
        }
      } @else {
        @if (currentBreadcrumb(); as current) {
          <span
            class="font-medium leading-normal text-neutral-low-dark"
            [class.text-sm]="size() === 'sm'"
            [class.text-base]="size() === 'md'"
            [class.text-lg]="size() === 'lg'"
            aria-current="page"
          >
            {{ current.label }}
          </span>
        }
      }
    </div>

    @if (showAncestorDropdown()) {
      <div
        [uiOverlay]="ancestorMenuOpen()"
        (clickOutside)="closeAncestorMenu()"
      ></div>
    }
  </nav>
}
